import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import type { UseTableReturn } from '../../hooks/useTable';
import { SeriesListItem } from '../SeriesListItem';
import { TableSeriesControl } from './TableSeriesControl';

interface Props {
  table: UseTableReturn;
}

export const TableSeriesList = (props: Props) => {
  const { table } = props;

  return (
    <ChakraV3.Stack w='full'>
      {table.participantBehaviours.map((behaviour) => (
        <SeriesListItem key={behaviour.id} behaviour={behaviour}>
          <TableSeriesControl participantBehaviourId={behaviour.id} table={table} />
        </SeriesListItem>
      ))}
    </ChakraV3.Stack>
  );
};
